import { render, staticRenderFns } from "./textCmp.vue?vue&type=template&id=807e64b6&scoped=true&"
import script from "./textCmp.vue?vue&type=script&lang=js&"
export * from "./textCmp.vue?vue&type=script&lang=js&"
import style0 from "./textCmp.vue?vue&type=style&index=0&id=807e64b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807e64b6",
  null
  
)

export default component.exports